
<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-3"><h4><b>{{ 'pages.createReceiptPage.receiptMode.mode' | translate }}</b></h4></div>

    <div [@openClose]="!isOpen ? 'open' : 'closed'">
      <div class="col-sm-3"><h4>{{selectedMode}}</h4></div>
      <div class="col-sm-3"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ 'pages.createReceiptPage.receiptMode.change' | translate }}</h4></div>
    </div>
  </div>
</div>
<div class="mring-lft" [@openClose]="isOpen ? 'open' : 'closed'">
  <div *ngFor="let receipt of receiptTypes; index as i" class="col-md-3 col-lg-3 col-sm-10">
    <button class="btn btn-mode" (click)="selectMode(receipt.Description)">
      <span class="armx-icon {{getModeClassName(receipt.ReceiptTypeId)}}"></span>
      {{getModeName(receipt)}}
    </button>
  </div>
</div>

